var _excluded = ["level", "size", "truncated"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { Text } from "../text/Text";
var HEADING_LEVELS = {
  '1': {
    fontSize: '42px',
    lineHeight: '1.6',
    fontWeight: 300
  },
  '2': {
    fontSize: 5,
    lineHeight: 5
  },
  '3': {
    fontSize: 4,
    lineHeight: 4
  },
  '4': {
    fontSize: 3,
    lineHeight: 3
  }
};
var HEADING_SIZES = {
  tiny: {
    fontSize: '8px',
    lineHeight: '10px',
    fontWeight: 600
  },
  small: {
    fontSize: '10px',
    lineHeight: '12px',
    fontWeight: 600
  },
  intermediate: {
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: 600
  },
  regular: {
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 600
  },
  medium: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600
  },
  large: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 600
  },
  xLarge: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '28px'
  },
  xxLarge: {
    fontSize: '28px',
    fontWeight: 600,
    lineHeight: '40px'
  },
  xxxLarge: {
    fontSize: '40px',
    fontWeight: 600,
    lineHeight: '56px'
  }
};
var Heading = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var level = _ref.level,
      size = _ref.size,
      _ref$truncated = _ref.truncated,
      truncated = _ref$truncated === void 0 ? false : _ref$truncated,
      others = _objectWithoutProperties(_ref, _excluded);

  var styles = _objectSpread(_objectSpread({}, HEADING_LEVELS), HEADING_SIZES);

  var style = size || level || '4';
  var styleProps = styles[style];
  return /*#__PURE__*/React.createElement(Text, _extends({
    ref: ref,
    fontWeight: "medium",
    truncated: truncated
  }, styleProps, others, {
    hyphens: true
  }));
});
Heading.displayName = 'Heading';
export { Heading };
export default Heading;